'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/gopd@1.2.0/~/gopd/gOPD.js
// module id = 727
// module chunks = 0